import { message } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SlotMachineContext, TeamContext } from "../../../context";

const MidGameWaitingRoom = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { showMidGameWaitingWindow } = useContext(SlotMachineContext);
    const gamePhase: number | undefined = game?.phase;
    const currentRound: number | undefined = game?.gameInfo?.challengeScore;
    const gamePhaseIsUndefinedText: string = "Game phase is undefined";

    // if (!gamePhase) return <div> {gamePhaseIsUndefinedText} </div>
    if (!showMidGameWaitingWindow) return null;

    const currentProgres = () => {
        switch(gamePhase) {
            case 4:  return "0%";
            case 5:  return "10%";
            case 7:  return "30%";
            case 14: return "60%";
            case 15: return "70%";
            case 8:  return "80%";
            case 13: return "90%";
            default: return "0%";
        }
    }

    const message = () => {
        return (
            <div>
                {/* <div> {t("thePlayersAreinTheRoundText")} {currentRound}</div> */}
                <div> {t("pleaseWaitForTheNewRoundText")} </div>
                <div> {t("theProgressOfTheCurrentRoundText")} </div>
                <div className="mid_game_waiting_room_progress_wrapper">
                    <div style={{ background: "white", width: currentProgres() }}></div>
                </div>
                <div>{currentProgres()}</div>
                <div> {t("pleaseDoNotCloseThisTabText")} </div>
            </div>
        )
    }

    return (
        <div className="mid_game_waiting_room_wrapper">
            <div className="mid_game_waiting_room_box">
                {message()}
            </div> 
        </div>
    )
}

export default MidGameWaitingRoom;